export const EN_APP_REVIEW_STRINGS = {
  APP_REVIEW: 'App Review',
  APP_REVIEW_PROMPTS: 'App Review Prompts',
  APP_REVIEW_PROMPT_ENTITY_NAME: 'App Review Prompt',
  APP_REVIEW_PROMPT_METADATA_LABEL: 'Metadata',
  APP_REVIEW_PROMPT_INTERNAL_NAME_LABEL: 'Internal name',
  APP_REVIEW_PROMPT_DESCRIPTION_LABEL: 'Description',
  APP_REVIEW_PROMPT_ENABLED_LABEL: 'Enabled',
  APP_REVIEW_PROMPT_PLATFORM_IOS_LABEL: 'iOS',
  APP_REVIEW_PROMPT_PLATFORM_ANDROID_LABEL: 'Android',
  APP_REVIEW_PROMPT_MINIMUM_APP_VERSIONS_LABEL: 'Minimum app versions',
  APP_REVIEW_PROMPT_IOS_MIN_VERSION_LABEL: 'iOS minimum version',
  APP_REVIEW_PROMPT_ANDROID_MIN_VERSION_LABEL: 'Android minimum version',
  APP_REVIEW_PROMPT_PRIORITY_LABEL: 'Priority',
  APP_REVIEW_PROMPT_TRIGGER_SOURCES_LABEL: 'Trigger sources',
  APP_REVIEW_PROMPT_TRIGGER_SOURCE_LABEL: 'Trigger source',
  APP_REVIEW_PROMPT_TRIGGER_SOURCE_ADD_LABEL: 'Add trigger source',
  APP_REVIEW_PROMPT_TRIGGER_SOURCE_ENABLED_LABEL: 'Trigger enabled',
  APP_REVIEW_PROMPT_TRIGGER_SOURCE_INTERNAL_NAME_LABEL: 'Trigger name',
  APP_REVIEW_PROMPT_TRIGGER_KEY_LABEL: 'Trigger key',
  APP_REVIEW_PROMPT_TRIGGER_SOURCE_PLATFORMS_LABEL: 'Trigger platforms',
  APP_REVIEW_PROMPT_TRIGGER_SOURCE_PLATFORM_LABEL: 'Trigger platform',
  APP_REVIEW_PROMPT_MIN_DAYS_BETWEEN_PROMPTS_LABEL:
    'Minimum days between prompts',
  APP_REVIEW_PROMPT_MAX_IMPRESSIONS_LABEL: 'Maximum impressions',
  APP_REVIEW_PROMPT_SUCCESS_VIEW_LABEL: 'Success view',
  APP_REVIEW_PROMPT_SUCCESS_VIEW_ENABLED_LABEL: 'Show success view',
  APP_REVIEW_PROMPT_SUCCESS_VIEW_NODE_ID_LABEL: 'Success node',
  APP_REVIEW_PROMPT_PRESENTATION_LABEL: 'Presentation',
  APP_REVIEW_PROMPT_ENGINE_LABEL: 'View engine',
  APP_REVIEW_PROMPT_MODE_LABEL: 'Presentation mode',
  APP_REVIEW_PROMPT_PROMPT_NODE_ID_LABEL: 'Prompt node',
  APP_REVIEW_PROMPT_FEEDBACK_NODE_ID_LABEL: 'Feedback node',
  APP_REVIEW_PROMPT_THANK_YOU_NODE_ID_LABEL: 'Thank-you node',
};
